import Vue from "vue";
import Vuex from "vuex";
import setting from "./setting";
import account from "./account";
import vokabel from "./vokabel";
import placementTest from "./placementTest";
import statistics from "./statistics";
// import notificationWSPlugin from "@/store/notificationWSPlugin";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    notification: []
  },
  mutations: {
    NOTIFICATION(state, data) {
      state.notification = data;
    }
  },
  actions: {},
  modules: {
    // alert,
    // feedback,
    account,
    setting,
    vokabel,
    placementTest,
    statistics
  }
  // plugins: [notificationWSPlugin]
});
